export default {
  getNextServer(info, firstGameServer) {
    // 現在の得点から次にサーブを出すプレイヤーの番号を返却
    const result = this.svJudge(info);
    let server = 0;
    if (result) {
      server = firstGameServer;
    } else {
      if (firstGameServer === 1) {
        server = 2;
      } else if (firstGameServer === 2) {
        server = 1;
      }
    }
    return server;
  },
  svJudge(info) {
    // 次のサーブがFirstGameServerかどうかを判定する
    let mod = 2;
    let com = 0;
    let result = true;
    if (info.p1 + info.p2 < 20) {
      mod = 4;
      com = 1;
    }
    if ((info.p1 + info.p2) % mod > com) {
      result = false;
    }
    if ((info.s1 + info.s2) % 2 === 1) {
      result = !result;
    }
    return result;
  },
  nextPoint(info, point) {
    const ret = info;
    ret.p1 += point;
    ret.p2 += point ^ 1;
    if (ret.p1 >= 11 || ret.p2 >= 11) {
      if ((ret.p1 - ret.p2) ** 2 >= 4) {
        if (ret.p1 > ret.p2) {
          ret.s1 += 1;
        } else {
          ret.s2 += 1;
        }
        ret.p1 = 0;
        ret.p2 = 0;
      }
    }
    return ret;
  },
  sumArr(arr) {
    if (arr.length === 0) {
      return 0;
    }
    // eslint-disable-next-line
    return arr.reduce(function(prev, current, i, arr) {
      return prev + current;
    });
  },
  round2(simResult) {
    if (!simResult) {
      return 0;
    }
    return Math.round(simResult * 100) / 100;
  },
  getFristGameServer(info, point, label) {
    // 得点は加算した状態で用いる
    let isPreServer = true;
    let preServer = 0;
    let firstGameServer = 0;
    // まずは今回のポイントでどっちがサーブだったのかを求める
    if (label % 2 === 0) {
      preServer = point ^ 1;
    } else {
      preServer = point;
    }
    // そのゲームのはじめのポイントのサーバーかどうか
    if (info.p1 + info.p2 > 20) {
      if (((info.p1 + info.p2) - 1) % 2 === 1) {
        isPreServer = false;
      }
    } else {
      if (((info.p1 + info.p2) - 1) % 4 > 1) {
        isPreServer = false;
      }
    }
    // 偶数ゲーム目なら反転
    if ((info.s1 + info.s2) % 2 === 1) {
      isPreServer = !isPreServer;
    }

    // isPreServerから実際にサーバーを求める
    if (isPreServer) {
      firstGameServer = preServer;
    } else {
      firstGameServer = preServer ^ 1;
    }
    firstGameServer = firstGameServer === 0 ? 2 : 1;
    return firstGameServer;
  },
  sliceData(selected, game) {
    // 選択されたゲームごとにstoreのpoints,labelsを選択して返却
    let info = {
      p1: 0,
      p2: 0,
      s1: 0,
      s2: 0,
    };
    let pointsData = [];
    let labelsData = [];
    let hitsData = [];
    let manualLabelData = {}; // eslint-disable-next-line
    for (let key of Object.keys(game.manualLabels)) {
      manualLabelData[key] = { name: key, value: [] };
    }
    for (let i = 0; i < game.points.length; i++) {
      if (selected === info.s1 + info.s2 + 1) {
        pointsData.push(game.points[i]);
        labelsData.push(game.labels[i]);
        if (game.isProMode) {
          hitsData.push(game.hitsList[i]);
        }
        // eslint-disable-next-line
        for (let key of Object.keys(game.manualLabels)){ 
          const v = game.manualLabels[key].value[i];
          manualLabelData[key].value.push(v);
        }
      }
      // 得点を進める
      info = this.nextPoint(info, game.points[i]);
    }
    const add = info.p1 + info.p2 > 0 ? 1 : 0;
    // add変数を算出するために、全ポイント選択時もループを回している
    if (!selected) {
      pointsData = game.points;
      labelsData = game.labels;
      if (game.isProMode) {
        hitsData = game.hitsList;
      }
      manualLabelData = game.manualLabels;
      return {
        points: pointsData,
        labels: labelsData,
        hitsList: hitsData,
        maxGameCnt: (info.s1 + info.s2 + add),
        manualLabels: manualLabelData,
      };
    }
    // 全ポイント選択時
    return {
      points: pointsData,
      labels: labelsData,
      hitsList: hitsData,
      maxGameCnt: (info.s1 + info.s2 + add),
      manualLabels: manualLabelData,
    };
  },
  getLabelData(points, labels) {
    const labels1 = [];
    const labels2 = [];
    labels1.length = Math.max(0, ...labels) + 1;
    labels2.length = Math.max(0, ...labels) + 1;
    labels1.fill(0);
    labels2.fill(0);
    for (let i = 0; i < points.length; i++) {
      if (points[i] === 1) {
        labels1[labels[i]] += 1;
      } else {
        labels2[labels[i]] += 1;
      }
    }
    return { 1: labels1, 2: labels2 };
  },
};



// WEBPACK FOOTER //
// ./src/lib/func.js